import React, { useState, useEffect, ReactNode } from 'react';
import { ControlledMessageModal, MessageModalCopy } from './ControlledMessageModal';

interface MessageModalProps {
  openTrigger?: boolean;
  icon: ReactNode;
  messageCopy: MessageModalCopy;
  ariaLabel?: string;
}

const MessageModal = ({ openTrigger, icon, messageCopy, ariaLabel }: MessageModalProps) => {
  const [open, setOpen] = useState(!!openTrigger);

  useEffect(() => {
    setOpen(!!openTrigger);
  }, [openTrigger]);

  const closeModal = () => setOpen(false);

  return (
    <ControlledMessageModal
      ariaLabel={ariaLabel}
      icon={icon}
      messageCopy={messageCopy}
      open={open}
      onClose={closeModal}
    />
  );
};

export default MessageModal;
